import React from 'react'
import PropTypes from 'prop-types'

import { Form } from '../../common/form/Form'

export const FormModal = ({
  setOpenFormModal,
  crud,
  envData,
  formSchema,
  modSchema,
  isAdd,
  defaultData,
  isViewOnly,
  setIsViewOnly,
  parentId,
  authDetails,
  isLocalEnvironment,
}) => {
  React.useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        setOpenFormModal(false)
        setIsViewOnly(false)
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])
  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              {formSchema.formTitle}
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                setOpenFormModal(false)
                setIsViewOnly(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <Form
              setOpenFormModal={setOpenFormModal}
              defaultData={defaultData}
              formSchema={formSchema}
              moduleSchema={modSchema}
              crud={crud}
              isAdd={isAdd}
              isViewOnly={isViewOnly}
              parentId={parentId}
              envData={envData}
              authDetails={authDetails}
              isLocalEnvironment={isLocalEnvironment}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

FormModal.propTypes = {
  setOpenFormModal: PropTypes.object,
  envData: PropTypes.object,
  formSchema: PropTypes.object,
  modSchema: PropTypes.object,
  isAdd: PropTypes.object,
  defaultData: PropTypes.object,
  isViewOnly: PropTypes.object,
  setIsViewOnly: PropTypes.object,
  parentId: PropTypes.object,
  authDetails: PropTypes.object,
  isLocalEnvironment: PropTypes.object,
  crud: PropTypes.number,
}
